import { addSnackMessage } from '@greenkub-fronts/domain/snackbar';
import { FixMe, Studio } from '@greenkub-fronts/shared/interface';
import { isExtension } from '@greenkub-fronts/shared/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash';

export const onChangeStudio = createAsyncThunk(
  'onChangeStudio',
  async (
    data: {
      origin: string;
      modelOdooId: string;
      finishOdooId: string;
      equipmentOdooId: string;
      configId: string;
    },
    { dispatch, getState }: { dispatch: any; getState: any }
  ) => {
    let newStudio = undefined;

    const catalogue = getState().api.queries['getCatalogue(undefined)']?.data;

    const configurationsPack = getState().upsell.configurationsPack;

    const configurationPack = getState().upsell.configurationsPack.find(
      (item: FixMe) => item.initialConfig.id === data.configId
    );

    if (isExtension(catalogue.models, data.modelOdooId)) {
      // GXM2
      const equipmentOdooId = '1'; // vide
      const finishOdooId = '6'; // access
      newStudio = catalogue.studio.find(
        (studio: Studio) =>
          studio.model.odooId == data.modelOdooId &&
          studio.finish.odooId == finishOdooId &&
          studio.equipment.odooId == equipmentOdooId
      );
    } else if (data.modelOdooId === '18') {
      // GK11S, equipement vide
      data.equipmentOdooId = '1'; // vide
      newStudio = catalogue.studios.find(
        (studio: Studio) =>
          studio.model.odooId == data.modelOdooId &&
          studio.finish.odooId == data.finishOdooId &&
          studio.equipment.odooId == data.equipmentOdooId
      );
    } else {
      newStudio = catalogue.studios.find(
        (studio: Studio) =>
          studio.model.odooId == data.modelOdooId &&
          studio.finish.odooId == data.finishOdooId &&
          studio.equipment.odooId == data.equipmentOdooId
      );
    }

    if (!newStudio) {
      dispatch(
        addSnackMessage('negative', 'Pas de studio avec cette combinaison')
      );
      return;
    }

    const config = configurationPack.editableConfig;
    config.chosenStudioList.studio = cloneDeep(newStudio);
    // si le nouveau model est une extension,
    if (isExtension(catalogue.models, data.modelOdooId)) {
      configurationPack.initialConfig.chosenStudioList.chosenStudio[0].surface =
        configurationPack.initialConfig.chosenStudioList.chosenStudio[0].surface
          ? configurationPack.initialConfig.chosenStudioList.chosenStudio[0]
              .surface
          : 0;
      config.chosenStudioList.chosenStudio = [];
      (newStudio as FixMe).surface = 10;
      config.chosenStudioList.chosenStudio.push(cloneDeep(newStudio));
    } else {
      const size = config.chosenStudioList.chosenStudio.length;
      config.chosenStudioList.chosenStudio = [];
      for (let i = 0; i < size; i++) {
        config.chosenStudioList.chosenStudio.push(cloneDeep(newStudio));
      }
    }

    if (origin === 'onChangeModel') {
      config.defaultOptionModelList.chosenOption = [];
    }

    if (origin === 'onChangeFinish' || origin === 'onChangeEquipment') {
      config.defaultOptionFinishEquipmentList.chosenOptions = [];
    }

    configurationsPack.forEach((item: any, key: number) => {
      if (item.initialConfig.id === configurationPack.initialConfig.id) {
        configurationsPack[key] = configurationPack;
      }
    });

    return {
      configurationsPack,
    };
  }
);
